<template>
    <form :action="action" class="registration-form" method="POST" v-if="form">
        <input type="hidden" name="_token" :value="csrkToken" />

        <md-card class="profil-form profil-form-data">
            <md-card-header>
                <h2 class="md-title md-title-dark" v-html="title" />
            </md-card-header>

            <md-card-content>
                 <div class="form-row">
                    <div :class="{ 'md-invalid': !!errors.entity_type }" class="entity-type-container">
                        <span>{{ entityTypeSelectionLabel }} : *</span>
                        <div class="flex">
                            <div class="flex items-center">
                                <md-radio v-model="fData.entity_type" value="company"></md-radio><span>{{ $t("registration.want-to-fly-pro") }}</span>
                            </div>
                            <div class="ml-20 flex items-center">
                                <md-radio v-model="fData.entity_type" value="individual"></md-radio><span>{{ $t("registration.want-to-fly-private") }}</span>
                            </div>
                        </div>
                        <span class="md-error">{{
                            errors.entity_type ? errors.entity_type[0] : ""
                        }}</span>
                    </div>
                </div>
                <div class="form-row" v-if="fData.entity_type == 'company'">
                    <md-field :class="{'md-invalid': !!errors.entity_name}">
                        <label>{{ $t('registration.entity-name') }}</label>
                        <md-input
                            type="text"
                            name="entity_name"
                            v-model="fData.entity_name"
                            :disabled="submitting ? 'disabled' : null"
                            dusk="entity-name-input"
                        />
                        <span
                            class="md-error"
                            v-html="errors.entity_name ? errors.entity_name[0] : ''"
                        />
                    </md-field>
                </div>
                <div class="form-row">
                    <div class="col">
                        <md-field :class="{'md-invalid': !!errors.lastname}">
                            <label>{{ $t('registration.lastname') }}</label>
                            <md-input
                                name="lastname"
                                v-model="fData.lastname"
                                :disabled="submitting ? 'disabled' : null"
                                required
                            />
                            <span class="md-error">{{ errors.lastname ? errors.lastname[0] : '' }}</span>
                        </md-field>
                    </div>
                    <div class="col">
                        <md-field :class="{'md-invalid': !!errors.firstname}">
                            <label>{{ $t('registration.firstname') }}</label>
                            <md-input
                                name="firstname"
                                v-model="fData.firstname"
                                :disabled="submitting ? 'disabled' : null"
                                required
                            />
                            <span class="md-error">{{ errors.firstname ? errors.firstname[0] : '' }}</span>
                        </md-field>
                    </div>
                </div>

                <div class="form-row">
                    <md-field :class="{ 'md-invalid': !!errors.entity_type }">
                        <label>{{ $t("registration.job-label") }}</label>
                        <md-select
                            name="role"
                            dusk="entity-type-input"
                            :disabled="submitting ? 'disabled' : null"
                            v-model="fData.role"
                        >
                            <md-option
                                :value="role.id"
                                :key="role.key"
                                v-for="role in userRoles"
                            >
                                {{ role.label }}
                            </md-option>
                        </md-select>
                        <span class="md-error">{{
                            errors.role ? errors.role[0] : ""
                        }}</span>
                    </md-field>
                </div>
                <div class="form-row">
                    <city-input
                        no-icon
                        name="city_id"
                        :label="$t('registration.your-city')"
                        :no-label="true"
                        v-model="fData['city_id']"
                        :city-name="fData['city_name']"
                        :input-error="errors['city_id']"
                        :disabled="submitting ? 'disabled' : null"
                        dusk="city-input"
                    />
                </div>
                <div class="form-row" :class="{'mt-35': !!errors.email}">
                    <phone-field
                        required
                        name="phone"
                        v-model="fData.phone"
                        :errors="errors.phone"
                        :label="$t('registration.mobile')"
                        mobile-only
                        :country-id="countryId"
                        ref="phoneInput"
                        :disabled="submitting ? 'disabled' : null"
                    />
                </div>

                <div class="form-row form-row-submit">
                    <div class="form-submit-button">
                        <p v-html="$t('registration.accept-tos')" />
                        <submit-button
                            type="submit"
                            class="registration-standalone-button"
                            :submitting="submitting"
                            :label="$t('registration.create_account')"
                            @click="onSubmit()"
                            dusk="submit-profile-button"
                        />
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </form>
</template>

<script>
import PhoneField from "../../widgets/PhoneFieldComponent.vue";
import CityInput from "../../widgets/CityInputComponent.vue";

export default {
    components: { PhoneField, CityInput },
    props: {
        action: {
            type: String,
            required: true,
        },
        formString: {
            type: String,
            required: true,
        },
        fromAirportId: {
            type: String,
            default: "",
        },
        toAirportId: {
            type: String,
            default: "",
        },
        countryId: {
            type: String,
        },
        entityRolesString: {
            type: String,
        },
        templateString: {
            type: String,
        },
        introPhrase: {
            type: String,
            default: "fill-profile-freemium",
        },
        entityTypesString: {
            type: String,
            required: true,
        },
        userRolesString: {
            type: String,
            required: true,
        },
        registrationPageId: String,
    },
    data() {
        return {
            fData: {
                lastname: "",
                firstname: "",
                phone: "",
                city_id: null,
                airport_id: null,
                entity_type: null,
                entity_name: null,
                role: null,
            },
            errors: {
                lastname: null,
                firstname: null,
                phone: null,
                city_id: null,
                airport_id: null,
                entity_type: null,
                entity_name: null,
                role: null,
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
        };
    },
    computed: {
        form() {
            return this.parseProp(this.formString);
        },
        template() {
            return this.parseProp(this.templateString) || {};
        },
        title() {
            if (
                !this.template.form_title ||
                !this.template.form_title[this.$i18n.locale()]
            ) {
                return this.$t("registration." + this.introPhrase);
            }

            return this.template.form_title[this.$i18n.locale()];
        },
        entityTypes() {
            return this.parseProp(this.entityTypesString);
        },
        userRoles() {
            return this.parseProp(this.userRolesString);
        },
        entityTypeSelectionLabel() {
            if(
                !this.template.entity_type_selection_label ||
                !this.template.entity_type_selection_label[this.$i18n.locale()]
            ) {
                return this.$t("registration.flight-as-label");
            }
            return this.template.entity_type_selection_label[this.$i18n.locale()];
        },
    },
    mounted() {
        this.setupForm();
    },
    methods: {
        parseProp(prop) {
            if (!prop) {
                return;
            }

            return JSON.parse(prop);
        },
        setupForm() {
            if (!this.form) {
                return;
            }

            for (let i of Object.keys(this.form)) {
                this.fData[i] = this.form[i];
            }

            this.fData.password_confirmation = this.fData.password;

            if (this.fromAirportId) {
                this.fData.airport_id = this.fromAirportId;
            }
            if (this.toAirportId) {
                this.fData.destination_airport_id = this.toAirportId;
            }
        },
        onSubmit() {
            this.submitting = true;

            for (let i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }

            axios
                .post(this.action, {
                    ...this.fData,
                    registration_page_id: this.registrationPageId,
                })
                .then(({ data }) => {
                    if (data.status === "ok") {
                        window.location = data.redirect;
                    }

                    this.submitting = false;
                })
                .catch(
                    ({
                        response: {
                            data: { errors },
                        },
                    }) => {
                        this.submitting = false;
                        for (let i of Object.keys(this.errors)) {
                            this.errors[i] = errors[i];
                        }
                    }
                );
        },
    },
};
</script>
<style lang="scss">
@import "~styles/_variables";
.registration-form {
    .md-title em {
        font-weight: 400;
        font-size: 0.95em;
    }
    .md-error {
        color: #ff1744;
            opacity: 1;
    transform: translateZ(0);
    }
    .entity-type-container {
        display: flex;
        flex-direction: column;
        width: auto;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 16px;
        span {
            font-size: 12px;
            font-weight: 600;
            color: $primary-color-dark;
        }
    }
}
.profil-form-data {
    .text-grey-light {
        color: rgba(0, 0, 0, 0.54);
        i {
            font-size: 10px;
        }
    }
    padding: 20px;
    .md-card-header {
        .md-title {
            font-size: 20px !important;
        }
    }
    .md-card-content {
        .md-field {
            label {
                font-size: 12px;
            }
        }
        .md-checkbox-label {
            font-size: 10px !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/formData.vue